import React, { useEffect, useState } from 'react'
import useMunicipalityUsers from 'api/hooks/use-employee-options'
import Select, { components } from 'react-select'

function UsersDropdown({ params, setParams, disabled = [] }) {
  const { isSuccess, isLoading, data: users } = useMunicipalityUsers({})
  const [selected, setSelected] = useState('')
  const { Option } = components

  const CustomOption = (props) => (
    <Option {...props}>
      <span className="me-1">{props.data.label}</span>
    </Option>
  )
  const SingleValue = ({ children, ...props }) => (
    <React.Fragment>
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </React.Fragment>
  )

  const options = isSuccess
    ? users.map((u) => ({
        label: u.full_name,
        value: u.id,
        disabled: disabled.includes(u.id)
      }))
    : []

  useEffect(() => {
    if (params.changedById && isSuccess) {
      const selectedOption = options.find(
        (option) => String(option.value) === String(params.changedById)
      )
      setSelected(selectedOption || '')
    } else {
      setSelected('')
    }
  }, [params.changedById, isSuccess]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minWidth: 170 }}>
      <Select
        options={options}
        value={selected}
        isClearable={true}
        isLoading={isLoading}
        placeholder="Changed by user"
        onChange={(val) => {
          setSelected(val)
          setParams({ ...params, changedById: val?.value || '' })
        }}
        id="changed-by-selector"
        isOptionDisabled={(option) => option.disabled}
        components={{ SingleValue, Option: CustomOption }}
      />
    </div>
  )
}

export default UsersDropdown
